import { useEffect, useState } from "react";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import { TourDeviationReportStore } from "../../../../store/main/TourDeviationReportStore";
import { ReportFilters } from "../../../../domain/models/report-filters";
import { TerritoryData } from "../../../../domain/models/territory-data";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import ReportFiltersLoading from "../../desktop/ReportFiltersLoading";
import ReportScreen from "../../../../common/enums/ReportScreens";
import DeviationPerformanceMobile from "./sub-component/DeviationPerformanceMobile";
import DeviationPerformanceChartMobile from "./sub-component/DeviationPerformanceChartMobile";
import ReportFiltersComponentMobile from "../ReportFiltersComponentMobile";
import RolesId from "../../../../common/enums/RoleIds";
import DeviationTableMobile from "./sub-component/DeviationTableMobile";
import { userTourCardDataResponse, UserTourCardResponse } from "../../desktop/tour-deviation-report/TourDeviationReportDesktop";

const TourDeviationReportMobile = () => {
const { userDetails, decodeToken, userRole } = CustomerDatabaseStore();
  const { addTourDeviation, addUserTourDeviation } = TourDeviationReportStore();
  const {
    zoneMasterData,
    regionMasterData,
    areaMasterData,
    headquarterMasterData,
  } = TerritoryDataStore();

  const currentDate = new Date();
  const defaultMonth = currentDate.getMonth() + 1;
  const defaultYear = currentDate.getFullYear();

  const [month, setMonth] = useState<number>(defaultMonth);
  const [year, setYear] = useState<number>(defaultYear);
  const [selectedZoneGACode, setSelectedZoneGACode] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [tourCardData, setTourCardData] = useState<UserTourCardResponse  | null>(null);
  const [userTourCardData, setUserTourCardData] = useState<userTourCardDataResponse | null>(null);
  const [selectedLevel, setSelectedLevel] = useState<"Self" | "ZBM" | "RBM" | "ABM" | "TSO">("Self");
    const [resetFiltersTrigger, setResetFiltersTrigger] = useState<number>(0);

  const roleMapping: Record<"Self" | "ZBM" | "RBM" | "ABM" | "TSO" | "CM", RolesId | 0> = {
  Self: 0,
  TSO: RolesId.HEADQUATER_MANAGER,
  ABM: RolesId.AREA_MANAGER,
  RBM: RolesId.REGION_MANAGER,
  ZBM: RolesId.ZONE_MANAGER,
  CM: RolesId.COUTNRY_MANAGER,
};

  // Decode token on mount
  useEffect(() => {
    decodeToken();
    const initialPayload = {
      month: defaultMonth.toString().padStart(2, "0"),
      year: defaultYear,
      scope: "self",
      ga_code: "",
    };
    addTourDeviationData(initialPayload);

    const userInitialPayload = {
      month: defaultMonth.toString().padStart(2, "0"),
      year: defaultYear,
      ga_code: "",
      scope: "self",
    };
    addUserTourDeviationData(userInitialPayload);
  }, []);

  // API function
  const addTourDeviationData = async (payload: {
    month: string;
    year: number;
    ga_code: string;
  }) => {
    setLoading(true);
    try {
      const responseData = await addTourDeviation(payload);
      if (responseData && responseData.success) {
        setTourCardData(responseData);
      }
    } catch (error) {
      console.error("Error fetching tour deviation data:", error);
    } finally {
      setLoading(false);
    }
  };

  const addUserTourDeviationData = async (payload: {
    month: string;
    year: number;
    ga_code: string;
    scope?: string;
  }) => {
    setLoading(true);
    try {
      const responseData = await addUserTourDeviation(payload);
      if (responseData && responseData.success) {
        setUserTourCardData({ ...responseData });
      }
    } catch (error) {
      console.error("Error fetching user tour deviation data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter data via UI
  const filterData = (filter: ReportFilters) => {
    let selectedGaCode: TerritoryData | undefined;

    // ✅ Pick latest selected GA code priority: Headquarter → Area → Region → Zone
    if (filter.headquarter?.length > 0) {
      selectedGaCode = headquarterMasterData.find(
        (item) => item.id.toString() === filter.headquarter[0]
      );
    } else if (filter.area?.length > 0) {
      selectedGaCode = areaMasterData.find(
        (item) => item.id.toString() === filter.area[0]
      );
    } else if (filter.region?.length > 0) {
      selectedGaCode = regionMasterData.find(
        (item) => item.id.toString() === filter.region[0]
      );
    } else if (filter.zone?.length > 0) {
      selectedGaCode = zoneMasterData.find(
        (item) => item.id.toString() === filter.zone[0]
      );
    }
    setSelectedZoneGACode(selectedGaCode ? selectedGaCode.ga_code : "");

    let selectedLevel: "Self" | "ZBM" | "RBM" | "ABM" | "TSO" = "Self";

if (filter.headquarter?.length > 0) {
  selectedLevel = "TSO";
} else if (filter.area?.length > 0) {
  selectedLevel = "ABM";
} else if (filter.region?.length > 0) {
  selectedLevel = "RBM";
} else if (filter.zone?.length > 0) {
  selectedLevel = "ZBM";
}

setSelectedLevel(selectedLevel);
const role_id = roleMapping[selectedLevel];

const isGeoSelected =
  filter.headquarter?.length > 0 ||
  filter.area?.length > 0 ||
  filter.region?.length > 0 ||
  filter.zone?.length > 0;

    // ✅ Extract month and year
    const monthValue = parseInt(moment(filter.date?.toString()).format("MM"));
    const yearValue = parseInt(moment(filter.date?.toString()).format("YYYY"));

    setMonth(monthValue);
    setYear(yearValue);

    // ✅ Create payload with latest GA code
    const filterPayload = {
      month: monthValue.toString().padStart(2, "0"),
      year: yearValue,
      ga_code: selectedGaCode ? selectedGaCode.ga_code : "",
       ...(role_id !== 0 && { role_id }),
        ...(!isGeoSelected && { scope: "self" })  
    };

    const userFilterPayload = {
      month: monthValue.toString().padStart(2, "0"),
      year: yearValue,
      ga_code: selectedGaCode ? selectedGaCode.ga_code : "",
       ...(role_id !== 0 && { role_id }),
       ...(!isGeoSelected && { scope: "self" })
    };
    // ✅ Trigger API call
    addTourDeviationData(filterPayload);
    addUserTourDeviationData(userFilterPayload);
  };

const clearData = async () => {
  setMonth(defaultMonth);
  setYear(defaultYear);
  setSelectedLevel("Self");
  setSelectedZoneGACode("");
      // 🔥 trigger UI reset signal
  setResetFiltersTrigger(prev => prev + 1);
  const payload = {
    month: defaultMonth.toString().padStart(2, "0"),
    year: defaultYear,
    scope: "self",
    ga_code: "",
  };

  setLoading(true);
  try {
    await Promise.all([
      addTourDeviationData(payload),
      addUserTourDeviationData(payload),
    ]);
  } finally {
    setLoading(false);
  }
};



const handleUserTabSwitch = (payload: any) => {
  // Explicit clear action from child
  if (payload?.action === "clear") {
    clearData();
    return;
  }

  // Backwards compatible: if child still sends scope:'self'
  if (payload?.scope === "self") {
    clearData();
    return;
  }

  addUserTourDeviationData(payload);
};

const handleTourTabSwitch = (payload: any) => {
  if (payload?.action === "clear") {
    clearData();
    return;
  }

  if (payload?.scope === "self") {
    clearData();
    return;
  }

  addTourDeviationData(payload);
};

  return (
    <Box sx={{ p: 2, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
      <Typography variant="h5" fontWeight={550} mb={2}>
        Tour Deviation Report
      </Typography>

      <Box mb={2}>
        {Object.keys(userDetails).length > 0 ? (
          <ReportFiltersComponentMobile
                key={resetFiltersTrigger} 
            type={ReportScreen.TOUR_DEVIATION_REPORT}
            successCallback={filterData}
            clearSuccessCallBack={clearData}
            userRole={userRole.role}
            userDetails={userDetails}
            gridColumns={9}
            territoryMultiSelect={false}
          />
        ) : (
          <ReportFiltersLoading />
        )}
      </Box>

      {/* Performance Card */}
      <Box mb={2}>
        <DeviationPerformanceMobile
        month={month}
            year={year}
            ga_code={selectedZoneGACode}
            tourCardData={tourCardData}
        />
      </Box>

      <Box mb={2}>
        <DeviationPerformanceChartMobile    month={month}
            year={year}
            ga_code={selectedZoneGACode}
            tourCardData={tourCardData} />
      </Box> 

      {/* Table */}
       <DeviationTableMobile  key={`${month}-${year}-${selectedZoneGACode}-${selectedLevel}`} // 🟢 ensures remount on filter change
        month={month}
        year={year}
        ga_code={selectedZoneGACode}
        userTourCardData={{ ...userTourCardData }} // 🟢 new reference every render
        userRoleId={userDetails?.role_id}
        autoSelectedTab={selectedLevel} // <-- NEW PROP
        // onTabSwitch={(payload) => addUserTourDeviationData({ ...payload })} // 🟢 new reference on tab
        onTabSwitchTour={(payload) => handleTourTabSwitch(payload)}
        onTabSwitchUser={(payload) => handleUserTabSwitch(payload)}/>
    </Box>
  );
};

export default TourDeviationReportMobile;